module.exports = __webpack_public_path__ + "img/vector.26029874.svg";